module.exports = __webpack_public_path__ + "img/more-horizontal-black.4d4b4622.svg";